<div class="form-group" [formGroup]="form">
  @if (label) {
    <label
      [for]="id"
      class="form-label"
      >
      {{ label }}
      @if (required) {
        <span class="required">*</span>
      }
    </label>
    }@if (tooltipText) {
    <app-tooltip-card [label]="tooltipLabel" [text]="tooltipText"></app-tooltip-card>
  }
  @if (icon) {
    <img class="form-icon" [src]="icon" [alt]="icon">
  }
  <input
    [id]="id"
    [value]="value"
    [type]="type"
    [formControlName]="id"
    [disabled]="disabled"
    [readonly]="readonly"
    class="form-control"
    [class]="{ 'readonly': readonly || disabled, 'form-icon-left': icon }"
    (click)="clickEvent()"
    (blur)="blurEvent($event)"
    [min]="min"
    (change)="preventOutOfRange($event)"
    [placeholder]="placeholder"
    >
  @if (helper) {
    <div class="form-helper">{{ helper }}</div>
  }
  @if (buttonText) {
    <button class="input-button" (click)="buttonClickEvent()">{{buttonText}}</button>
  }
</div>
